import RuejaiClubLayout from "./RuejaiClubLayout";
import { ruejaiClubBannerRoutes } from "./modules/banner/routes";
import { ruejaiClubCategoryRoutes } from "./modules/category/routes";
import { ruejaiClubSalePackageRoutes } from "./modules/sale-package/routes";
import { ruejaiClubVoucherPackageRoutes } from "./modules/voucher-package/routes";
import { ruejaiClubGroupCategoryRoutes } from "./modules/group-category/routes";
import { ruejaiClubTierRoutes } from "./modules/tier/routes";

export const ruejaiClubRoutes = {
  path: "ruejai-club",
  component: RuejaiClubLayout,
  children: [
    ...ruejaiClubBannerRoutes(),
    ...ruejaiClubCategoryRoutes(),
    ...ruejaiClubSalePackageRoutes(),
    ...ruejaiClubVoucherPackageRoutes(),
    ...ruejaiClubGroupCategoryRoutes(),
    ...ruejaiClubTierRoutes()
  ]
};



// WEBPACK FOOTER //
// ./src/features/ruejai-club/routes.js